import React, { useState, useEffect } from "react";
import { colors } from "../../themes/Colors";
import { BaseButton } from "../atoms";
import useWindowDimensions from "../../get-diemensions/UseWindowDiemensions";

const LoginPopUp = ({ display, setClose, width }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      onClick={() => (hover ? null : setClose(false))}
      style={{
        height: display ? "100%" : 0,
        width: width > 599 ? width : width,
        position: "fixed",
        zIndex: 101,
        top: 0,
        backgroundColor: colors.bgSecondary,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <div
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
        style={{
          width: width > 599 ? 200 : "50%",
          maxWidth: 500,
          maxHeight: 500,
          //   height: "50%",
          paddingBottom: 20,
          minWidth: width > 599 ? 200 : 400,
          //   minHeight: 400,
          borderRadius: 8,
          backgroundColor: colors.white,
          zIndex: 2,
          position: "absolute",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          WebkitBoxShadow: "0px 0px 7px 2px #00000010",
          top: width > 599 ? null : 0,
        }}
      >
        <div
          style={{
            fontSize: 18,
            fontWeight: "bold",
            width: "80%",
            marginTop: 20,
            marginBottom: 20,
            textAlign: "center",
          }}
        >
          SELECT WHICH REGION YOU WOULD LIKE TO LOGIN INTO?
        </div>
        <div
          style={{
            width: "100%",
            flex: 1,
            // borderStyle: "solid",
            display: "flex",
            flexDirection: "column",
            overflowX: "hidden",
            overflowY: "scroll",
            alignItems: "center",
          }}
        >
          <BaseButton
            width={"90%"}
            label={"WESTERN CAPE"}
            href={"https://rooftop420pharmacy.web.app/"}
          />
          <div style={{ minHeight: 20 }} />
          <BaseButton
            width={"90%"}
            label={"GAUTENG"}
            href={"https://alter-pharm.web.app/"}
          />
          <div style={{ minHeight: 20 }} />
          <BaseButton
            width={"90%"}
            label={"KWA-ZULU NATAL"}
            href={"https://alter-pharm.web.app/"}
          />
          <div style={{ minHeight: 20 }} />
          <BaseButton
            width={"90%"}
            label={"CLOSE"}
            onClick={() => setClose(false)}
          />
        </div>
      </div>
    </div>
  );
};

export default LoginPopUp;
